export default __webpack_public_path__ + "static/media/8.2c8191eb.svg";